











import Vue from 'vue';
import { FormFieldValidation } from '@/mixins/formValidation';
import { ValidationModel } from '@/types/models/validation';

export default Vue.extend({
  name: 'MStoreFormCheckbox',
  mixins: [FormFieldValidation],
  props: {
    value: {
      required: false
    },
    label: {
      type: String,
      default: ''
    },
    validation: {
      type: Object as () => ValidationModel,
      default: () => ({} as ValidationModel)
    },
    id: {
      type: String,
      required: true
    },
    name: String,
    isDisabled: Boolean,
    switch: Boolean,
    size: String
  },
  computed: {
    inputValue: {
      get(this: any) {
        return this.value;
      },
      set(this: any, value: string) {
        this.$emit('input', value);
      }
    },
    checkboxClass(this: any) {
      return `${this.switch ? 'custom-switch' : ''} ${this.isDisabled ? 'noselect opacity-65' : ''}`;
    },
    sizeAdjustedLabel(this: any) {
      return this.size === 'sm' ? '' : this.label;
    }
  }
});
